import style from "./QuantityInput.module.scss";
import cn from "classnames";

export function QuantityInput({
    value,
    setValue
}: {
    value: number,
    setValue: (newValue: number) => void
}) {
    return (
        <div className={style.container}>
            <p className={style.label}>К-сть:</p>
            <input
                type="text"
                value={value}
                onChange={(e) => {
                    setValue(Number(e.target.value.replace(/\D/g, "")) || 1)
                }}
                className={style.value}
            />
            <div className="flex flex-col gap-[7px]">
                <div
                    className={style.arrow}
                    onClick={() => {
                        setValue(value + 1)
                    }}
                ></div>
                <div
                    className={cn(style.arrow, "rotate-180")}
                    onClick={() => {
                        if ((value - 1) <= 0) {
                            setValue(1)
                        } else {
                            setValue(value - 1)
                        }
                    }}
                ></div>
            </div>
        </div>
    )
}